export const host = '//www.aiphoto8.cn';
// 正式
//const env = process.env.NODE_ENV === 'development' ? '/dev' : '/'
// const env = process.env.NODE_ENV === 'development' ? '' : ''
// console.log('env', env);

export const apiHost = `https://www.aiphoto8.cn/api`;

// export const graphqlApi = `//hui51.cn${env}/api/graphql`;

export const graphqlApi =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3033/api/graphql'
    : 'https://www.aiphoto8.cn/api/graphql';
export const debugInfo = (...args) => {
  if (process.env.NODE_ENV === 'development' || window.isDebug) {
    console.log(`[DEBUG]`, ...args);
  }
};
